import Styled from 'styled-components/macro';
import {tokensForThemeProvider} from '@forecast-it/design-system';

/**
 * The decision form sits inside the activity card rather than in a modal, so it needs to read as a
 * nested surface. NestedCard carries its own collapse behaviour and a fixed sub-component API, and
 * Card is a different shape, so the chrome is drawn here from the shared tokens.
 */
export const DecisionPanel = Styled.div`
	display: flex;
	flex-direction: column;
	gap: ${tokensForThemeProvider.sky.sys.spacing[400]};
	padding: ${tokensForThemeProvider.sky.sys.spacing[400]};
	background-color: ${tokensForThemeProvider.sky.sys.color.background.neutral['2']};
	border: 1px solid ${tokensForThemeProvider.sky.sys.color.border.decorative};
	border-radius: ${tokensForThemeProvider.sky.sys.spacing[200]};
`;

/** Label column and control, so the control keeps a stable left edge across both decisions. */
export const FieldRow = Styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: ${tokensForThemeProvider.sky.sys.spacing[600]};

	/* Sized to the label so it never wraps mid-phrase, with the gap doing the separating. */
	> :first-child {
		flex: 0 0 auto;
		white-space: nowrap;
	}

	/* Runs to the panel's right edge, so the control lines up with the buttons beneath it. */
	> :last-child {
		flex: 1 1 auto;
		min-width: 0;
	}
`;
